import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["stepProps", "wizardProps"];
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { filterTokenProps } from '../../../utils/filterTokenProps';
import { usePanelContext } from '../../context/PanelContext';
import { DialogCloseButton } from '../DialogCloseButton';
import { DialogHeader } from '../DialogHeader';
import { Text } from '../../../components/Text/Text';
import styled from 'foundations-theming/utils';

// TODO: abstract into full types & move out as we build up our Wizard implementation
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledWizardHeader = styled.div.withConfig({
  displayName: "WizardHeader__StyledWizardHeader",
  componentId: "nj2p6r-0"
})(({
  $cssStyles
}) => {
  return Object.assign({}, $cssStyles);
});
export const WizardHeader = _ref => {
  let {
      stepProps = {},
      wizardProps = {}
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps,
    restProps
  } = filterTokenProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const {
    inPanel
  } = usePanelContext();
  const heading = stepProps.heading || wizardProps.defaultHeading;
  if (heading == null) return null;
  return /*#__PURE__*/_jsxs(StyledWizardHeader, Object.assign({}, restProps, {
    $cssStyles: cssStyles,
    children: [inPanel && /*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: wizardProps.onReject,
      "data-wizard-action-name": "close"
    }), /*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: heading
      })
    })]
  }));
};